<template>
	<div class="icon-circle">
		<img :src="src" class="icon-circle__image" />
	</div>
</template>

<script>
export default {
	name: 'IconCircle',
	props: {
		icon: {
			type: String,
			default: `person`,
		},
		bg: {
			type: String,
			default: 'mint',
		},
		size: {
			type: [Number, String],
			default: 54,
		},
	},
	computed: {
		classes() {
			let classes = []
			classes.push(`icon-circle--${this.bg}`)
		},
		src() {
			return this.$src(`/assets/icons/${this.icon}.svg`)
		}
	},
}
</script>

<style scoped lang="scss">
.icon-circle {
	background-color: var(--background, var(--color--mint));
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	height: var(--size, 60px);
	width: var(--size, 60px);
	padding: 0.8rem;

	&__image {
		max-width: 100%;
	}
}
</style>
